// extracted by mini-css-extract-plugin
export default {"breadCrumb":"BreadCrumb_breadCrumb__y3pwF","mainIcon":"BreadCrumb_mainIcon__QrYi4","separatorIcon":"BreadCrumb_separatorIcon__iVp2T"};